// This file stored the fields used in Query Builder.
// The fields correspond to the columns definition used by Ag-Grid.
// The definitions here are tightly coupled with the data model on the backend.
// This tight coupling is generally undesirable (as changes to the backend require changes here).

import { enums } from "../../../data";

const enum2values = (items) => {
  return items.map((item) => ({
    name: typeof item === "object" ? item.value : item,
    label: typeof item === "object" ? item.label : item,
  }));
};

const fields = [
  {
    name: "row",
    label: "Row No.",
    inputType: "number",
  },
  // Personal Info
  {
    name: "jhed",
    label: "JHED",
    inputType: "string",
  },
  {
    name: "firstName",
    label: "First Name",
    inputType: "string",
  },
  {
    name: "lastName",
    label: "Last Name",
    inputType: "string",
  },
  {
    name: "preferredName",
    label: "Preferred Name",
    inputType: "string",
  },
  // Application Info
  {
    name: "createdAt",
    label: "Created At",
    inputType: "date",
  },
  {
    name: "status",
    label: "Application Status",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.applicationStatus),
  },
  //Admin
  {
    name: "evaluation",
    label: "Last CA Evaluation",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.evaluation),
  },
  {
    name: "adminFeedback",
    label: "Admin Feedback",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.adminFeedback),
  },
  {
    name: "hiredFor",
    label: "Hired for",
    inputType: "string",
  },
  // Academics
  {
    name: "program",
    label: "Program",
    inputType: "string",
  },
  {
    name: "gradePointAverage",
    label: "GPA",
    inputType: "number",
  },
  {
    name: "classYear",
    label: "Class Year",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.classYear),
  },
  // Experience
  {
    name: "experience",
    label: "Teaching Experience (General)",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.teachingExperience),
  },
  // Availability
  {
    name: "creditHours",
    label: "Credit Hours",
    inputType: "number",
  },
  {
    name: "availableHours",
    label: "Available Hours",
    inputType: "number",
  },
  {
    name: "otherJobHours",
    label: "Other Job Hours",
    inputType: "number",
  },
  // HR Info
  {
    name: "enrollmentStatus",
    label: "Enrollment Status",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.enrollmentStatus),
  },
  {
    name: "residency",
    label: "Residency",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.residency),
  },
  {
    name: "workStudy",
    label: "Has Work-Study permit?",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.yesNo),
  },
  {
    name: "payroll",
    label: "Last on payroll?",
    inputType: "select",
    valueEditorType: "select",
    values: enum2values(enums.payroll),
  },
  // Referee
  {
    name: "refereeName",
    label: "Referee Name",
    inputType: "string",
  },
];

const choices = [
  "",
  "(1st choice)",
  "(2nd choice)",
  "(3rd choice)",
  "(4th choice)",
];

for (let c = 1; c <= 4; c++) {
  fields.push(
    {
      name: `course${c}`,
      label: `Course ${choices[c]}`,
      inputType: "string",
    },
    {
      name: `grade${c}`,
      label: `Grade ${choices[c]}`,
      inputType: "select",
      valueEditorType: "select",
      values: enum2values(enums.grades),
    },
    {
      name: `experience${c}`,
      label: `Teaching Experience ${choices[c]}`,
      inputType: "select",
      valueEditorType: "select",
      values: enum2values(enums.courseExperience),
    },
    {
      name: `head${c}`,
      label: `Interested in head/lead? ${choices[c]}`,
      inputType: "select",
      valueEditorType: "select",
      values: enum2values(enums.yesNo),
    },
    {
      name: `instructorFeedback${c}`,
      label: `Instructor Feedback ${choices[c]}`,
      inputType: "select",
      valueEditorType: "select",
      values: enum2values(enums.instructorFeedback),
    }
  );
}

export default fields;
